// src/components/StationBlockItem.jsx
import React from 'react';
import { trainKindClass, trainKindTrainsIconText } from '../../data/trainKinds';
import { trainHtmlClass, displayDelay, destinationStationName } from '../../services/trainsService';

function destinationText(train) {
  if (![11, 15, 18, 22, 25, 30].includes(train.destination_station_id)) {
    return '';
  }

  return destinationStationName(train).substring(0, 1);
}

const StationBlockItem = ({ trains, keyPrefix, trainBodyClass, eventsEmit }) => (
  <div key={keyPrefix} className="station-block-item">
    {trains.map((train, idx) => {
      const isDelay = train.delay && train.delay > 59;

      return (
        <a
          href={`/lines/mainline/trains/${train.train_number}`}
          key={`${keyPrefix}_${idx}`}
          className={`train-icon train${train.train_number} ${isDelay ? 'is-delay' : ''}`}
          onClick={
            (event) => {
              event.preventDefault();
              eventsEmit('train_position.train', { train_number: train.train_number });
              window.location.href = event.currentTarget.href;
            }
          }
        >
          <div
            className={`train-body ${trainHtmlClass(train)} ${trainKindClass(train.train_kind_id)} ${trainBodyClass}`}
            data-destination={destinationText(train)}
            data-type={trainKindTrainsIconText(train.train_kind_id)}
          />
          {isDelay ? (
            <p className={`train-delay ${train.direction}`}>
              {displayDelay(train.delay)}
            </p>
          ) : null}
        </a>
      );
    })}
  </div>
);

export default StationBlockItem;
